import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

const publicApi = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: false,
  headers: { 'Content-Type': 'application/json' },
});

// Add token from localStorage as fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function formatApiError(detail) {
  if (!detail) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export const authAPI = {
  register: async (name, email, password) => {
    const response = await api.post('/auth/register', { name, email, password });
    if (response.data.token) {
      localStorage.setItem('auth_token', response.data.token);
    }
    return response.data;
  },

  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    if (response.data.token) {
      localStorage.setItem('auth_token', response.data.token);
    }
    return response.data;
  },

  getMe: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  logout: async () => {
    await api.post('/auth/logout');
    localStorage.removeItem('auth_token');
  },
};

export { formatApiError };

export const productsAPI = {
  getAll: async () => {
    const response = await publicApi.get('/products');
    return response.data;
  },
  getOne: async (id) => {
    const response = await publicApi.get(`/products/${id}`);
    return response.data;
  },
};

export const ordersAPI = {
  create: async (items) => {
    const response = await api.post('/orders', { items });
    return response.data;
  },
  getAll: async () => {
    const response = await api.get('/orders');
    return response.data;
  },
  getOne: async (orderId) => {
    const response = await api.get(`/orders/${orderId}`);
    return response.data;
  },
  confirmPayment: async (orderId) => {
    const response = await api.post(`/orders/${orderId}/confirm`);
    return response.data;
  },
};

export const supportAPI = {
  getConversations: async () => {
    const response = await api.get('/conversations');
    return response.data;
  },
  sendMessage: async (message) => {
    const response = await api.post('/conversations/messages', { message });
    return response.data;
  },
  sendAnonymousMessage: async (data) => {
    const response = await api.post('/support/messages', data);
    return response.data;
  },
};

export default api;
